/* eslint-disable react/no-danger */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';
import { getImageAtSize } from '../../lib/utils';

import { useThemeClassName } from '../../contexts/ThemeContext';
import Button from '../buttons/Button';

import styles from '../../../styles/blocks/card.module.scss';

const propTypes = {
    className: PropTypes.string,
    isContainer: PropTypes.bool,
    containerClassName: PropTypes.string,
    image: AppPropTypes.image,
    title: PropTypes.string,
    body: PropTypes.string,
    label: PropTypes.string,
    url: PropTypes.string,
};

const defaultProps = {
    className: null,
    isContainer: false,
    containerClassName: null,
    image: null,
    title: null,
    body: null,
    label: null,
    url: null,
};

const CardBlock = ({
    className,
    isContainer,
    containerClassName,
    image,
    title,
    body,
    label,
    url,
}) => {
    const themeClassName = useThemeClassName(styles);
    const { url: imageUrl = null, alt: imageAlt = null } =
        getImageAtSize(image, 'medium', false) || {};

    const inner = (
        <div
            className={classNames([
                styles.inner,
                {
                    [styles.isContainer]: isContainer,
                    // [containerClassName]: isContainer && containerClassName !== null,
                },
            ])}
        >
            <div className={styles.content}>
                {imageUrl !== null ? (
                    <div className={styles.imageContainer}>
                        <div className={styles.frame}>
                            <img
                                className={styles.image}
                                src={typeof image === 'string' ? image : imageUrl}
                                alt={imageAlt}
                            />
                        </div>
                    </div>
                ) : null}
                <div className={styles.text}>
                    {title !== null ? <h4 className={styles.title}>{title}</h4> : null}
                    {body !== null ? (
                        <div
                            className={classNames(styles.body, 'card-body')}
                            dangerouslySetInnerHTML={{ __html: body }}
                        />
                    ) : null}
                </div>
            </div>
            {label !== null ? (
                <div
                    className={classNames(styles.label, 'card-label')}
                    dangerouslySetInnerHTML={{ __html: label }}
                />
            ) : null}
        </div>
    );

    return (
        <div
            className={classNames([
                styles.container,
                themeClassName,
                {
                    [styles.isContainer]: isContainer,
                    [containerClassName]: isContainer && containerClassName !== null,
                    [className]: className !== null,
                },
            ])}
        >
            {url !== null ? (
                <Button
                    href={url}
                    external={url.match(/https?:\/\//) !== null}
                    target="_self"
                    className={styles.button}
                >
                    {inner}
                </Button>
            ) : (
                inner
            )}
        </div>
    );
};

CardBlock.propTypes = propTypes;
CardBlock.defaultProps = defaultProps;

export default CardBlock;
